import { useMemo } from 'react';
import { useSessionStore } from '@/entities/session';
import { useUserProfileInfo } from '@/entities/user';
import { getFullName, getInitial, getShortName } from '../lib';

export const useUserIdentity = () => {
  const { session } = useSessionStore();
  const { userProfileInfoMap, isUserProfileInfoLoading } = useUserProfileInfo();

  const isVerified = session?.additional?.isVerified ?? false;
  const isCorporate = Boolean(session?.additional?.isCorporate) && isVerified;
  const accountId = session?.additional?.eWallet ?? '';

  const names = useMemo(() => {
    const firstName = userProfileInfoMap?.firstName;
    const lastName = userProfileInfoMap?.lastName;
    const companyName = userProfileInfoMap?.companyName?.trim();

    if (isCorporate && companyName) {
      return { shortName: companyName, fullName: companyName };
    }

    return {
      shortName: getShortName(firstName, lastName),
      fullName: getFullName(firstName, lastName),
    };
  }, [userProfileInfoMap, isCorporate]);

  return {
    isVerified,
    isCorporate,
    accountId,
    initial: getInitial(
      userProfileInfoMap?.firstName,
      userProfileInfoMap?.lastName
    ),
    ...names,
    isLoading: isUserProfileInfoLoading,
  };
};
